/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';
import { connect } from 'react-redux';

import { Toastify } from 'src/services';
import appConfig from 'src/appConfig';
import { Icon, Text, View } from '../common';
import { IAppState } from 'src/store';
import './styles.scss';

const FileUpload: React.FC<Props> = ({ onChange }) => {
  const [myFiles, setMyFiles] = useState<File[]>([]);
  const [rejectFiles, setRejectFiles] = useState<FileRejection[]>([]);

  const onDrop = (acceptedFiles: File[], fileRejections: FileRejection[]) => {
    setMyFiles(acceptedFiles);
    setRejectFiles(fileRejections);
  };

  // List MIME can be found here:
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept:
      '.jpg, .jpeg, .png, .pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .txt, .odt, .mp3, .m4a, .wav, .mp4, .m4v, .mpg, .wmv, .mov, .avi, .swf, .zip, .rar, .7z, .ptx',
    maxSize: appConfig.MAXIMUM_FILE_SIZE,
  });

  useEffect(() => {
    if (rejectFiles.length > 0) {
      rejectFiles.forEach(file => {
        try {
          if (file.errors[0].code === 'file-too-large') {
            Toastify.error(file.errors[0].message);
          } else {
            Toastify.error('File is not supported');
          }
        } catch (error) {
          Toastify.error('File can not uploaded');
        }
      });
    }
  }, [rejectFiles]);

  useEffect(() => {
    if (myFiles.length > 0) onChange(myFiles);
  }, [myFiles]);

  // For more info about react dropzone follow:
  // https://react-dropzone.js.org/
  return (
    <View className="cmp-file-upload mb-24">
      <View {...getRootProps({ className: 'cmp-file-upload__body' })}>
        <input {...getInputProps()} />
        <View isRow align="center">
          <Icon name="ic_plus" className="mr-8" /> <Text>{'CLICK HERE TO UPLOAD FILE(S) OR DRAG & DROP HERE'}</Text>
        </View>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onChange: (...args: any[]) => void;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);
